import React, { useEffect } from 'react'
import HousekeepingTable from './HousekeepingTable';
import { useParams } from 'react-router';
import { useGetProfileQuery } from '../../profile/hooks/useGetProfileQuery';

const HousekeepingContent: React.FC = () => {
    const { id } = useParams();

    if (id) {
        localStorage.setItem('authToken', id);
    }

    const { data: user, isFetching, isSuccess } = useGetProfileQuery();

    useEffect(() => {
        if (isSuccess && user) {
            localStorage.setItem('user', JSON.stringify(user.data));
        }
    }, [isSuccess, user]);


    return (
        <div className="container-fluid mt-5">
            <div className="table-container">
                <h3 className="mb-3">Housekeeping</h3>
                <div className="p-4 mb-4 rounded shadow-sm" style={{ backgroundColor: '#f1f3f5' }}>
                    {isFetching ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <p className="mb-0 fs-3 fw-bold">
                            Welcome '{user?.data.name}', This is the housekeeping access
                        </p>
                    )}
                </div>
                {!isFetching && isSuccess && (
                    <HousekeepingTable />
                )}
            </div>
        </div>
    )
}

export default HousekeepingContent